import { Fragment } from "react/jsx-runtime";
import { Card, CardBody, Col, Row } from "reactstrap";
import { H6, ProgressBar } from "../../../../AbstractElements";
import { ProgressType } from "../../../../Types/CommonComponentsType";
import CommonCardHeader from "../../../CommonComponents/CommonCardHeader/CommonCardHeader";

const CommonProgress:React.FC<ProgressType> = ({ title, span, data, striped, animated, tag, progressClass, value }) => {
  return (
    <Card>
      <CommonCardHeader title={title} span={span} />
      <CardBody className={`progress-showcase`}>
        <Row>
          <Col>
            {data &&
              data.map((item, index) => (
                <Fragment key={index}>
                  {tag && <H6 className="mb-2">{item.text}</H6>}
                  <ProgressBar className={progressClass} key={index} style={{ height: item.text }} color={item.class} value={item.value} striped={striped} animated={animated}>
                    {value && item.value + "%"}
                  </ProgressBar>
                </Fragment>
              ))}
          </Col>
        </Row>
      </CardBody>
    </Card>
  );
};

export default CommonProgress;
